<template>
	<v-form
		ref="form"
		v-model="ui.valid"
		lazy-validation
		@submit.prevent="send()"
	>
		<v-row>
			<v-col cols="12 mb-8">
				<div class="d-flex align-center">
					<v-btn
						fab
						text
						class="elevation-2 mr-3"
						small
						@click="$router.go(-1)"
					>
						<v-icon>
							mdi-arrow-left
						</v-icon>
					</v-btn>
					<h1>
						Actualizar contraseña
					</h1>
				</div>

				<span>
					¿Ya tiene cuenta?
					<router-link :to="{ name: 'Login' }">
						Iniciar sesión
					</router-link>
				</span>
			</v-col>

			<template v-if="!ui.success">
				<v-col cols="12" class="pb-0 pt-0">
					<v-text-field
						outlined
						autocomplete="off"
						v-model="layout.email"
						label="Correo electrónico"
						:rules="[v.email]"
					></v-text-field>
				</v-col>

				<v-col cols="12" class="pb-0 pt-0">
					<v-text-field
						outlined
						clearable
						label="Nueva contraseña"
						autocomplete="off"
						v-model="layout.password"
						:rules="[v.required]"
						:type="ui.showPassword ? 'text' : 'password'"
						:append-icon="
							ui.showPassword ? 'mdi-eye' : 'mdi-eye-off'
						"
						@click:append="ui.showPassword = !ui.showPassword"
						@keydown.enter="register()"
					></v-text-field>
				</v-col>

				<v-col cols="12" class="pb-0 pt-0">
					<v-text-field
						outlined
						clearable
						label="Nueva contraseña(confirmación)"
						autocomplete="off"
						v-model="layout.password_confirmation"
						:rules="[v.required]"
						:type="ui.showPassword ? 'text' : 'password'"
						:append-icon="
							ui.showPassword ? 'mdi-eye' : 'mdi-eye-off'
						"
						@click:append="ui.showPassword = !ui.showPassword"
						@keydown.enter="register()"
					></v-text-field>
				</v-col>

				<v-col cols="12" class="pb-0 pt-0">
					<v-btn
						large
						color="primary"
						@click="send()"
						:disabled="!ui.valid"
						:loading="ui.sending"
						:block="$vuetify.breakpoint.smAndDown"
					>
						enviar
					</v-btn>
				</v-col>
			</template>

			<template v-else>
				<v-col cols="12" class="pb-0 pt-0">
					<v-alert
						type="success"
						text
						prominent
						class="d-flex flex-column"
					>
						<h3>
							¡Correcto!
						</h3>
						<p>
							¡La contraseña fue actualizada correctamente!
						</p>

						<div class="d-flex justify-end">
							<v-btn
								color="success"
								@click="$router.replace({ name: 'Login' })"
							>
								acceder ahora
							</v-btn>
						</div>
					</v-alert>
				</v-col>
			</template>
		</v-row>
	</v-form>
</template>

<script>
import { EventBus } from "@/main";
import axios from "axios";
import Validations from "@/../../GeneralComponents/Validations";

export default {
	data() {
		return {
			v: Validations,

			layout: {
				email: null,
				password: null,
				password_confirmation: null,
			},

			ui: {
				valid: true,
				sending: false,
				success: false,
				showPassword: false,
			},
		};
	},

	methods: {
		async send() {
			if (this.$refs.form.validate()) {
				this.ui.sending = true;

				try {
					let response = await axios.post(
						`${process.env.VUE_APP_API_SERVER}/password/reset`,
						{ ...this.layout, token: this.$route.params.token }
					);

					this.ui.success = true;
				} catch (error) {
					EventBus.$emit("Error", {
						error: error,
						errorsShow: true,
					});
				} finally {
					this.ui.sending = false;
				}
			}
		},
	},
};
</script>

<style lang="css" scoped></style>
